import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/researchgate': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32V480H448V32H0zM262.2 366.4C255.6 369.4 229 372.4 212.2 352.2 203 341.6 186.9 318.9 170 288.6 161.1 288.6 155.3 288.6 148.6 288V334.4C148.6 357.9 154.6 355.6 174.4 358.3V366.4C167.5 366.1 151.3 365.6 138.8 365.6 125.7 365.6 112.7 366.2 105.2 366.4V358.3C120.7 355.4 127.2 357 127.2 334.4V225C127.2 202.4 120.8 204 105.2 201.1V193C131 194 158.3 192.4 176.1 192.4 207.8 192.4 232 206.8 232 238 232 259.1 215.3 280.2 192.8 285.5 206.4 309.7 222.8 331.1 235 344.4 242.2 352.2 252.2 359.1 262.2 359.1V366.4zM285.1 231.4C261.8 231.4 252.9 215.7 252.9 199.2V167C252.9 154.8 261.7 136.6 286.9 136.6S317.3 154.5 317.3 154.5L306.6 161.7S301.1 149.2 286.9 149.2C279 149.2 267.2 156.5 267.2 168.9V195.7C267.2 209.1 273.8 219 285.1 219 299.2 219 306.6 208.1 306.6 192.2H288.7V181.5H319.1C319.1 202 323.8 231.4 285.1 231.4zM168.6 276.1C159.2 276.1 155 275.8 148.6 275.3V205.6C155 205 163.6 205 171.1 205 194.4 205 208.3 217.2 208.3 239.5 208.3 261.4 193.3 276.1 168.6 276.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/researchgate.js
// module id = TU6h
// module chunks = 144